export { ColourPickerComponent } from '../../fields/ColourPicker/Component.js'
